import {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {useDeleteClientNameMutation} from "../../../services/authService";
import ConfirmDialog from "../../ConfirmDialog";
import messages from "../../../utils/messages";
import styles from "./DeleteClientName.module.scss";

const DeleteClientName = ({ clientName, setClientName, onDelete,setSelectedClientId }) => {
    const [deleteClientName, { isSuccess, error, reset }] = useDeleteClientNameMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteClientName(clientName.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteClientName}`, { variant: 'success' });
            reset();
            onDelete();
            setClientName('');
            setSelectedClientId(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete client name"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteClientName}
            </ConfirmDialog>
        </>
    )
}

export default DeleteClientName;